import React from 'react'
import { Box, Grid } from '@mui/material'
// import Invites from './Invites'
// import ManageNetwork from './ManageNetwork'
import MessageChat from './MessageChat'
import ManageNetwork from '../Connections/ManageNetwork'
import NewsLetter from './NewsLetter'
// import SidebarUserList from './SidebarUserList'
// import PostBox from './PostBox'

const MessageChatHome = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        {/* Main Section */}
        {/* <Grid item md={8.5} xs={12} sm={12}> */}
        <Grid
          item
          size={{ md: 9, xs: 12, sm: 12 }}
        >
          <MessageChat />
        </Grid>

        {/* Side Content */}
        {/* <Grid item md={3.5} xs={12} sm={12}
         */}
        <Grid
          item
          size={{ md: 3, xs: 12, sm: 12 }}
          sx={{ background: "white",boxShadow:4, height: "fit-content" }}>
          <NewsLetter />
        </Grid>
      </Grid>
    </Box>
  )
}

export default MessageChatHome
  